import { useEffect, useState } from "react";
import { useApi } from "./useApi";
import api from "../lib/api";

// Server-paged list: first page via useApi (auto-reload on path change), "load more" appends.
export function usePagedList(path) {
  const { data } = useApi(path);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) { setItems(data.items); setTotal(data.total); } }, [data]);
  const loadMore = async () => {
    setBusy(true);
    try {
      const sep = path.includes("?") ? "&" : "?";
      const r = await api.get(`${path}${sep}skip=${items.length}`);
      setItems((prev) => [...prev, ...r.data.items]); setTotal(r.data.total);
    } finally { setBusy(false); }
  };
  const replace = (row) => setItems((p) => p.map((x) => (x.id === row.id ? row : x)));
  return { data, items, total, busy, loadMore, replace, hasMore: items.length < total };
}
